import React, { Component } from "react";
import { Admin } from "react-admin";
import "./App.css";
import "./styles/notificationStyles.css";
import GlobalNotificationProvider from "./components/GlobalNotificationProvider";
import { API_ROOT } from "./api-config";
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS,
} from "react-admin";

import { prop } from "ramda";
import routes from "./routes";
import resources from "./resources";
import MyLayout from "./MyLayout";
import ImtbikeTheme from "./ImtbikeTheme";
import reducer from "./reducer";
import dataProviderFactory from "./dataProvider";
import addUploadFeature from "./dataProvider/addUploadFeature";

import LoginPage from "./LoginPage";
import { Dashboard } from "./dashboard";
import { loadPermissions } from "./rbac";

const setPermissions = async () => {
  const response = await fetch(`${API_ROOT}/user_permission`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.token}`,
    },
  });

  if (response.status === 200) {
    const objPermissions = await response.json();
    const permissions = prop("permissions", objPermissions);
    localStorage.setItem("permissions", JSON.stringify(permissions));
    return permissions;
  }
  return {};
};

const authProvider = async (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username: email, password } = params;
    const admin = true;
    const request = new Request(`${API_ROOT}/auth/login`, {
      method: "POST",
      body: JSON.stringify({ email, password, admin }),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(async ({ token, user }) => {
        localStorage.setItem("token", token);
        localStorage.setItem("email", user.email);
        await setPermissions();
      })
      .catch((error) => {throw new Error("Something went wrong ...")});
  }
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("permissions");
    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    const { status } = params;
    return status === 401 || status === 403
      ? Promise.reject()
      : Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    return localStorage.getItem("token") && localStorage.getItem("permissions")
      ? Promise.resolve()
      : Promise.reject({ redirectTo: "/login" });
  }
  if (type === AUTH_GET_PERMISSIONS) {
    const permissions = await setPermissions();
    return permissions;
  }

  localStorage.removeItem("token");
  //localStorage.removeItem("user");
  localStorage.removeItem("permissions");
  return Promise.reject({ redirectTo: "/login" });
};

class App extends Component {
  state = { dataProvider: null };
  async componentWillMount() {
    const _dataProvider = await dataProviderFactory(
      //process.env.REACT_APP_DATA_PROVIDER
      "rest"
    );

    const dataProvider = addUploadFeature(_dataProvider);
    this.setState({ dataProvider });
    // Cargar mapa de permisos desde public/permissions.json (sin recompilar)
    loadPermissions().then(() => this.setState({ rbacReady: true }));
  }

  render() {
    const { dataProvider } = this.state;
    if (!dataProvider) {
      return (
        <div className="loader-container">
          <div className="loader">Loading...</div>
        </div>
      );
    }
    return (
      <GlobalNotificationProvider>
        <Admin
          theme={ImtbikeTheme}
          loginPage={LoginPage}
          dashboard={Dashboard}
          customReducers={{ reducer }}
          customRoutes={routes}
          authProvider={authProvider}
          dataProvider={dataProvider}
          appLayout={MyLayout}
        >
          {resources}
        </Admin>
      </GlobalNotificationProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js